import { Component, HostBinding, inject, Input, OnInit } from '@angular/core';

import { Colors2 } from '@23degrees/shared-code/models';
import { ColorManager } from '@23degrees/shared/manager/color/color.manager';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'loading-indicator',
  templateUrl: 'loading-indicator.component.html',
  styleUrls: ['./loading-indicator.scss'],
  imports: [NgStyle],
})
export class LoadingIndicatorComponent implements OnInit {
  private colorManager = inject(ColorManager);

  _colors: Array<any> = ['rgba(255,255,255,0.25)', 'rgba(255,255,255,0.5)', 'rgba(255,255,255,0.75)', 'rgba(255,255,255,1)'];

  @Input() set colors(colors: Colors2) {
    if (colors) {
      if (colors.type === 'continuous' && !colors.continuous) {
        return;
      }

      this._colors = this.colorManager.getStyleColorsByCount(colors, 4);
    }
  }

  get coloring() {
    return this.customColoring || this._colors;
  }
  @Input() dark: boolean = false;
  @Input() circle: boolean = false;
  @Input() label: string = null;
  @Input() icon: string = null;
  @Input() ignoreColors: boolean = false;
  @Input() autoColors: boolean = false;

  @Input() customColoring: any[];

  @HostBinding('class.withinOverlay') @Input() withinOverlay: boolean = false;

  @HostBinding('class.withBgColor') @Input() withBgColor: boolean = false;

  @HostBinding('class.relative') @Input() relative: boolean = false;

  ngOnInit() {
    if (this.dark) {
      this._colors = ['rgba(0,0,0,0.25)', 'rgba(0,0,0,0.5)', 'rgba(0,0,0,0.75)', 'rgba(0,0,0,1)'];
    }
  }
}
